import "@/App.css";
import "@/lib/auth";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Gallery from "@/pages/Gallery";
import ProjectDetail from "@/pages/ProjectDetail";
import About from "@/pages/About";
import Diario from "@/pages/Diario";
import Prints from "@/pages/Prints";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProjectEditor from "@/pages/admin/AdminProjectEditor";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <Routes>
            {/* ADMIN routes — bare (no layout chrome) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/projects/:slug" element={<ProtectedRoute><AdminProjectEditor /></ProtectedRoute>} />

            {/* PUBLIC routes — wrapped by Layout */}
            <Route path="*" element={
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/galeria/:categoria" element={<Gallery />} />
                  <Route path="/proyecto/:slug" element={<ProjectDetail />} />
                  <Route path="/sobre-mi" element={<About />} />
                  <Route path="/diario" element={<Diario />} />
                  <Route path="/prints" element={<Prints />} />
                  <Route path="*" element={<Home />} />
                </Routes>
              </Layout>
            } />
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
